var _global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : global;

var exports = {};
var module = {
  exports: exports
};
!function (a, t) {
  module.exports = t(null, exports, module);
}(exports, function (a, t, n) {
  var e = function (a, t, n, e, i, r) {
    for (var o = 0, s = ["webkit", "moz", "ms", "o"], m = 0; m < s.length && !window.requestAnimationFrame; ++m) window.requestAnimationFrame = window[s[m] + "RequestAnimationFrame"], window.cancelAnimationFrame = window[s[m] + "CancelAnimationFrame"] || window[s[m] + "CancelRequestAnimationFrame"];

    window.requestAnimationFrame || (window.requestAnimationFrame = function (a, t) {
      var n = new Date().getTime(),
          e = Math.max(0, 16 - (n - o)),
          i = window.setTimeout(function () {
        a(n + e);
      }, e);
      return o = n + e, i;
    }), window.cancelAnimationFrame || (window.cancelAnimationFrame = function (a) {
      clearTimeout(a);
    });
    var u = this || _global;
    u.options = {
      useEasing: !0,
      useGrouping: !0,
      separator: ",",
      decimal: ".",
      easingFn: null,
      formattingFn: null
    };

    for (var l in r) r.hasOwnProperty(l) && (u.options[l] = r[l]);

    "" === u.options.separator && (u.options.useGrouping = !1), u.options.prefix || (u.options.prefix = ""), u.options.suffix || (u.options.suffix = ""), u.d = "string" == typeof a ? document.getElementById(a) : a, u.startVal = Number(t), u.endVal = Number(n), u.countDown = u.startVal > u.endVal, u.frameVal = u.startVal, u.decimals = Math.max(0, e || 0), u.dec = Math.pow(10, u.decimals), u.duration = 1000 * Number(i) || 2000, u.formatNumber = function (a) {
      a = a.toFixed(u.decimals), a += "";
      var t, n, e, i;
      if (t = a.split("."), n = t[0], e = t.length > 1 ? u.options.decimal + t[1] : "", i = /(\d+)(\d{3})/, u.options.useGrouping) for (; i.test(n);) n = n.replace(i, "$1" + u.options.separator + "$2");
      return u.options.prefix + n + e + u.options.suffix;
    }, u.easeOutExpo = function (a, t, n, e) {
      return n * (-Math.pow(2, -10 * a / e) + 1) * 1024 / 1023 + t;
    }, u.easingFn = u.options.easingFn ? u.options.easingFn : u.easeOutExpo, u.formattingFn = u.options.formattingFn ? u.options.formattingFn : u.formatNumber, u.version = function () {
      return "1.7.1";
    }, u.printValue = function (a) {
      var t = u.formattingFn(a);
      "INPUT" === u.d.tagName ? (this || _global).d.value = t : "text" === u.d.tagName || "tspan" === u.d.tagName ? (this || _global).d.textContent = t : (this || _global).d.innerHTML = t;
    }, u.count = function (a) {
      u.startTime || (u.startTime = a), u.timestamp = a;
      var t = a - u.startTime;
      u.remaining = u.duration - t, u.options.useEasing ? u.countDown ? u.frameVal = u.startVal - u.easingFn(t, 0, u.startVal - u.endVal, u.duration) : u.frameVal = u.easingFn(t, u.startVal, u.endVal - u.startVal, u.duration) : u.countDown ? u.frameVal = u.startVal - (u.startVal - u.endVal) * (t / u.duration) : u.frameVal = u.startVal + (u.endVal - u.startVal) * (t / u.duration), u.countDown ? u.frameVal = u.frameVal < u.endVal ? u.endVal : u.frameVal : u.frameVal = u.frameVal > u.endVal ? u.endVal : u.frameVal, u.frameVal = Math.round(u.frameVal * u.dec) / u.dec, u.printValue(u.frameVal), t < u.duration ? u.rAF = requestAnimationFrame(u.count) : u.callback && u.callback();
    }, u.start = function (a) {
      return u.callback = a, u.rAF = requestAnimationFrame(u.count), !1;
    }, u.pauseResume = function () {
      u.paused ? (u.paused = !1, delete u.startTime, u.duration = u.remaining, u.startVal = u.frameVal, requestAnimationFrame(u.count)) : (u.paused = !0, cancelAnimationFrame(u.rAF));
    }, u.reset = function () {
      u.paused = !1, delete u.startTime, u.startVal = t, cancelAnimationFrame(u.rAF), u.printValue(u.startVal);
    }, u.update = function (a) {
      cancelAnimationFrame(u.rAF), u.paused = !1, delete u.startTime, u.startVal = u.frameVal, u.endVal = Number(a), u.countDown = u.startVal > u.endVal, u.rAF = requestAnimationFrame(u.count);
    }, u.printValue(u.startVal);
  };

  return e;
});
export default module.exports;